function captureAccountCodeFromPerformance() {
  try {
    const entries = performance.getEntriesByType('resource') || []
    for (let i = entries.length - 1; i >= 0; i--) {
      const name = entries[i].name
      if (!name || name.indexOf('distribution/account') === -1) continue
      const u = new URL(name, window.location.origin)
      const c = u.searchParams.get('accountCode')
      if (c) return c
    }
  } catch (_) {
    /* ignore */
  }
  return null
}

function captureYearFromPerformance() {
  try {
    const entries = performance.getEntriesByType('resource') || []
    for (let i = entries.length - 1; i >= 0; i--) {
      const name = entries[i].name
      if (!name || name.indexOf('distribution/account') === -1) continue
      const u = new URL(name, window.location.origin)
      const y = u.searchParams.get('year')
      if (y) return y
    }
  } catch (_) {
    /* ignore */
  }
  return null
}

/** Wirtschaftsjahr shown in the header (updates when the year dropdown changes; URL may not). */
function parseYearFromDistributionHeader() {
  const header = document.querySelector('.DistributionKeyDetailsHeader')
  if (!header) return null
  const text = (header.textContent || '').replace(/\s+/g, ' ')
  const range = text.match(/(\d{2})\.(\d{2})\.(\d{4})\s*[—–-]\s*(\d{2})\.(\d{2})\.(\d{4})/)
  if (range) return range[3]
  const single = text.match(/(\d{2})\.(\d{2})\.(\d{4})/)
  if (single) return single[3]
  return null
}

/**
 * Calendar year for distribution/account API. Prefer live UI + recent host fetches over the
 * year from the initial route match (SPA can change Wirtschaftsjahr without rematching).
 */
function resolveDistributionEconomicYear(urlYearFallback) {
  const fromHeader = parseYearFromDistributionHeader()
  if (fromHeader) return fromHeader
  try {
    const path = window.location.pathname || ''
    const pathMatch = path.match(/\/distribution-keys\/[^/]+\/(\d{4})\//)
    if (pathMatch) return pathMatch[1]
  } catch (_) {
    /* ignore */
  }
  if (window.__wegLastDistributionAccountYear) {
    return window.__wegLastDistributionAccountYear
  }
  const fromPerf = captureYearFromPerformance()
  if (fromPerf) return fromPerf
  return String(urlYearFallback || '')
}

/** Account code is not in the URL; try header typography, then captured fetch, then performance buffer. */
function resolveDistributionAccountCode() {
  if (window.__wegLastDistributionAccountCode) {
    return window.__wegLastDistributionAccountCode
  }
  const header = document.querySelector('.DistributionKeyDetailsHeader')
  if (header) {
    const candidates = header.querySelectorAll('h1, h2, h3, h4, .ant-typography, span, div')
    for (const el of candidates) {
      const t = (el.textContent || '').trim()
      if (!t || t.length > 32) continue
      const m = t.match(/^(\d+(?:\/\d+)*)$/)
      if (m) return m[1]
    }
  }
  return captureAccountCodeFromPerformance()
}

function buildUnitNrToUnitIdMapFromTable() {
  const map = new Map()
  const tbody = document.querySelector('#distributionKeyDetails .ant-table-tbody')
  if (!tbody) return map
  tbody.querySelectorAll('tr').forEach((row) => {
    const key = row.getAttribute('data-row-key')
    if (key == null || key === '') return
    const unitId = Number(key)
    if (Number.isNaN(unitId)) return
    const tds = row.querySelectorAll('td')
    if (tds.length < 2) return
    const unitNr = (tds[1].textContent || '').trim()
    if (unitNr) map.set(unitNr, unitId)
  })
  return map
}

function getAllowedUnitIdsForSelection(unitSetId, unitSets, distribution) {
  const unitList = distribution.unitDistributions || []
  if (unitSetId === 'all') {
    return new Set(unitList.map((ud) => ud.unitId))
  }
  const selectedSet = unitSets.find((us) => String(us.id) === String(unitSetId))
  if (!selectedSet || !Array.isArray(selectedSet.units)) {
    return new Set()
  }
  const allowed = new Set()
  for (const u of selectedSet.units) {
    if (u.id != null) allowed.add(Number(u.id))
  }
  const needsNrLookup = selectedSet.units.some(
    (u) => u.id == null && u.unitNrSharingDeclaration != null,
  )
  if (needsNrLookup) {
    const nrToId = buildUnitNrToUnitIdMapFromTable()
    for (const u of selectedSet.units) {
      if (u.id != null) continue
      const nr = u.unitNrSharingDeclaration != null ? String(u.unitNrSharingDeclaration).trim() : ''
      if (nr && nrToId.has(nr)) allowed.add(nrToId.get(nr))
    }
  }
  return allowed
}

function mergeUnitSetFlagsIntoDistribution(distribution, allowedUnitIds) {
  const body = JSON.parse(JSON.stringify(distribution))
  for (const ud of body.unitDistributions || []) {
    const on = allowedUnitIds.has(ud.unitId)
    ud.houseMoneySettlement = on
    ud.economicPlan = on
  }
  return body
}

/**
 * Units in the set must have both HGA + WP on; every other unit must have both off.
 * Partial rows (only one checkbox) never match a named preset or "Alle Einheiten".
 */
function distributionMatchesAllowedPattern(allowedUnitIds, distribution) {
  for (const ud of distribution.unitDistributions || []) {
    const hga = !!ud.houseMoneySettlement
    const wp = !!ud.economicPlan
    if (allowedUnitIds.has(ud.unitId)) {
      if (!hga || !wp) return false
    } else if (hga || wp) {
      return false
    }
  }
  return true
}

/** If distribution equals a preset exactly (full on / full off per unit), return `{ id, label }`; else null. */
function findMatchingUnitSetSelection(unitSets, distribution) {
  const rows = distribution.unitDistributions || []
  if (rows.length === 0) return null
  const allIds = new Set(rows.map((ud) => ud.unitId))
  if (distributionMatchesAllowedPattern(allIds, distribution)) {
    return { id: 'all', label: 'Alle Einheiten' }
  }
  for (const us of unitSets) {
    const allowed = getAllowedUnitIdsForSelection(us.id, unitSets, distribution)
    if (allowed.size === 0) continue
    if (distributionMatchesAllowedPattern(allowed, distribution)) {
      return { id: us.id, label: us.name || 'Unbenannt' }
    }
  }
  return null
}

/** Impower page: Bearbeiten may sit above `.PageContent` under `.DistributionKeyDetail` / `.overlay-page`. */
function getDistributionKeyDetailsActionScope() {
  const header = document.querySelector('.DistributionKeyDetailsHeader')
  if (!header) return null
  return (
    header.closest('.DistributionKeyDetail') ||
    header.closest('.overlay-page') ||
    header.closest('.PageContent') ||
    header.closest('.ant-card') ||
    header.closest('.ant-collapse-content') ||
    header.closest('.form-section-wrapper') ||
    header
  )
}

const onDistributionKeysPageMatch = async (pathname, regex) => {
  const urlParams = pathname.match(regex)
  const propertyHrId = urlParams[1]
  const economicYear = urlParams[2]

  let propertyId = null
  let isInjecting = false

  // Fetch property data to get propertyId
  const fetchPropertyData = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('auth'))?.token
      if (!token) throw new Error('Auth Token nicht gefunden.')

      const response = await fetch(
        `/services/pmp-accounting/api/v1/properties/${propertyHrId}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to fetch property data: ${response.statusText}`)
      }

      const propertyData = await response.json()
      return propertyData
    } catch (error) {
      console.error('Error fetching property data:', error)
      throw error
    }
  }

  // Fetch unit-sets data
  const fetchUnitSets = async (propertyId) => {
    try {
      const token = JSON.parse(localStorage.getItem('auth'))?.token
      if (!token) throw new Error('Auth Token nicht gefunden.')

      const response = await fetch(
        `/services/pmp-accounting/api/v1/unit-sets?propertyId=${propertyId}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to fetch unit-sets: ${response.statusText}`)
      }

      const unitSetsData = await response.json()
      return Array.isArray(unitSetsData) ? unitSetsData : []
    } catch (error) {
      console.error('Error fetching unit-sets:', error)
      return []
    }
  }

  // Create and inject select element
  const injectUnitSetsSelect = async () => {
    // Check if select already exists in the entire document to avoid duplicates
    if (document.querySelector('.weg-unit-sets-select')) {
      return true
    }

    // Prevent concurrent executions
    if (isInjecting) {
      return false
    }

    const row = document.querySelector('.DistributionKeyDetailsHeader > .ant-row')
    if (!row) {
      return false
    }
    
    // Get all ant-col-8 elements and select the third one
    const cols = row.querySelectorAll('.ant-col.ant-col-8')
    const targetElement = cols[2] // Third element (0-indexed)
    if (!targetElement) {
      return false
    }

    // Double-check before starting injection
    if (targetElement.querySelector('.weg-unit-sets-select') || document.querySelector('.weg-unit-sets-select')) {
      return true
    }

    isInjecting = true

    try {
      // Fetch property data to get propertyId
      if (!propertyId) {
        const propertyData = await fetchPropertyData()
        propertyId = propertyData.id || propertyData.propertyId
        if (!propertyId) {
          throw new Error('Property ID not found in property data')
        }
      }

      // Fetch unit-sets
      const unitSets = await fetchUnitSets(propertyId)

      // Start in read-only mode (will be updated by button clicks)
      let isReadOnly = true
      let selectedUnitSetId = null // 'all' for "Alle Einheiten", or unit set ID
      let isUpdatingCheckboxes = false // Flag to prevent recursive updates
      /** Bumped synchronously when the user picks a preset; prefill must not overwrite UI after that. */
      let unitSetPrefillEpoch = 0
      const bumpUnitSetPrefillEpoch = () => {
        unitSetPrefillEpoch += 1
      }

      const toast = typeof showToast === 'function' ? showToast : null

      const applyUnitSetSelection = async (unitSetId) => {
        isUpdatingCheckboxes = true
        try {
          const token = JSON.parse(localStorage.getItem('auth'))?.token
          if (!token) throw new Error('Auth Token nicht gefunden.')

          const accountCode = resolveDistributionAccountCode()
          if (!accountCode) {
            throw new Error('Kontencode konnte nicht ermittelt werden (Seite neu laden oder Konto wählen).')
          }

          const current = await fetchDistributionAccount({
            token,
            propertyId,
            year: resolveDistributionEconomicYear(economicYear),
            accountCode,
          })
          const allowed = getAllowedUnitIdsForSelection(unitSetId, unitSets, current)
          const body = mergeUnitSetFlagsIntoDistribution(current, allowed)
          await putDistributionAccount({ token, body })
          if (toast) toast('Einheitenset übernommen – Seite wird neu geladen…', 'success', 4000)
          setTimeout(() => window.location.reload(), 800)
        } catch (err) {
          console.error('[Unit Sets] distribution/account:', err)
          if (toast) toast(err.message || 'Verteiler konnte nicht gespeichert werden.', 'error', 6000)
        } finally {
          setTimeout(() => {
            isUpdatingCheckboxes = false
          }, 150)
        }
      }

      // Create select container
      const selectContainer = document.createElement('div')
      selectContainer.className = 'weg-unit-sets-select'
      selectContainer.style.cssText = `
        width: 100%;
      `

      // Add heading
      const heading = document.createElement('div')
      heading.textContent = 'Einheitenset'
      heading.style.cssText = `
        margin-bottom: 8px;
        font-size: 16px;
        margin-top: 4px;
        margin-bottom: 10px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
      `
      selectContainer.appendChild(heading)

      // Create select element
      const selectWrapper = document.createElement('div')
      selectWrapper.className = `ant-select ant-select-single impowerx-select${isReadOnly ? ' ant-select-disabled' : ''}`
      selectWrapper.style.cssText = `
        width: 100%;
      `

      const selectSelector = document.createElement('div')
      selectSelector.className = 'ant-select-selector'
      selectSelector.style.cssText = `
        position: relative;
        background-color: ${isReadOnly ? '#eee' : '#fff'};
        border-radius: .6rem;
        border: ${isReadOnly ? '.2rem solid transparent;' : '.2rem solid #eee;'};
        transition: all 0.3s;
        cursor: ${isReadOnly ? 'not-allowed' : 'pointer'};
        min-height: 40px;
        opacity: 1;
      `

      const selectSelection = document.createElement('div')
      selectSelection.className = 'ant-select-selection-search'
      selectSelection.style.cssText = `
        position: absolute;
        top: 0;
        right: 11px;
        bottom: 0;
        left: 11px;
      `

      const selectSelectionInput = document.createElement('input')
      selectSelectionInput.className = 'ant-select-selection-search-input'
      selectSelectionInput.type = 'text'
      selectSelectionInput.autocomplete = 'off'
      selectSelectionInput.role = 'combobox'
      selectSelectionInput.readOnly = true
      selectSelectionInput.style.cssText = `
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        cursor: pointer;
      `

      const selectSelectionItem = document.createElement('span')
      selectSelectionItem.className = 'ant-select-selection-item'
      selectSelectionItem.textContent = 'Einheitenset auswählen...'
      selectSelectionItem.style.cssText = `
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 11px;
        right: 11px;
        font-weight: 500;
        font-size: 16px;
        color: ${isReadOnly ? '#757575' : '#000'};
      `

      const selectArrow = document.createElement('span')
      selectArrow.className = 'ant-select-arrow'
      selectArrow.innerHTML = `
        <span role="img" class="anticon">
          <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="currentColor"></path>
          </svg>
        </span>
      `
      selectArrow.style.cssText = `
        position: absolute;
        top: 50%;
        right: 11px;
        pointer-events: none;
        color: rgba(0, 0, 0, 0.85);
      `

      selectSelection.appendChild(selectSelectionInput)
      selectSelector.appendChild(selectSelection)
      selectSelector.appendChild(selectSelectionItem)
      selectSelector.appendChild(selectArrow)
      selectWrapper.appendChild(selectSelector)

      // Create dropdown
      const dropdownWrapper = document.createElement('div')
      dropdownWrapper.className = 'dropdown-wrapper'
      dropdownWrapper.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 2000;
      `

      const dropdown = document.createElement('div')
      dropdown.className = 'ant-select-dropdown ant-select-dropdown-placement-bottomLeft ant-select-dropdown-hidden impowerx-select-dropdown'
      dropdown.style.cssText = `
        width: 100%;
        left: 0;
        top: 35px;
        background: #fff;
        border: 1px solid #d9d9d9;
        border-radius: .6rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        max-height: 256px;
        overflow-y: auto;
      `

      const dropdownContent = document.createElement('div')
      dropdownContent.className = 'rc-virtual-list'
      dropdownContent.style.cssText = `
        position: relative;
      `

      const dropdownHolder = document.createElement('div')
      dropdownHolder.className = 'rc-virtual-list-holder'
      dropdownHolder.style.cssText = `
        max-height: 256px;
        overflow-y: auto;
      `

      const dropdownInner = document.createElement('div')
      dropdownInner.className = 'rc-virtual-list-holder-inner'
      dropdownInner.style.cssText = `
        display: flex;
        flex-direction: column;
      `

      // Add "Alle Einheiten" option first
      const alleEinheitenOption = document.createElement('div')
      alleEinheitenOption.className = 'ant-select-item ant-select-item-option'
      alleEinheitenOption.dataset.value = 'all'
      alleEinheitenOption.textContent = 'Alle Einheiten'
      alleEinheitenOption.style.cssText = `
        padding: 8px 12px;
        cursor: ${isReadOnly ? 'not-allowed' : 'pointer'};
        transition: background-color 0.3s;
      `
      if (!isReadOnly) {
        alleEinheitenOption.onmouseenter = () => {
          alleEinheitenOption.style.backgroundColor = '#eee'
        }
        alleEinheitenOption.onmouseleave = () => {
          alleEinheitenOption.style.backgroundColor = 'transparent'
        }
        alleEinheitenOption.onclick = (e) => {
          e.stopPropagation()
          bumpUnitSetPrefillEpoch()
          selectedUnitSetId = 'all'
          selectSelectionItem.textContent = 'Alle Einheiten'
          selectSelectionItem.style.color = '#000'
          dropdown.classList.add('ant-select-dropdown-hidden')
          void applyUnitSetSelection('all')
        }
      }
      dropdownInner.appendChild(alleEinheitenOption)

      // Add options
      if (unitSets.length === 0) {
        const emptyOption = document.createElement('div')
        emptyOption.className = 'ant-select-item ant-select-item-option ant-select-item-option-disabled'
        emptyOption.textContent = 'Keine Einheitensets verfügbar'
        emptyOption.style.cssText = `
          padding: 8px 12px;
          color: rgba(0, 0, 0, 0.25);
        `
        dropdownInner.appendChild(emptyOption)
      } else {
        unitSets.forEach((unitSet) => {
          const option = document.createElement('div')
          option.className = 'ant-select-item ant-select-item-option'
          option.dataset.value = unitSet.id
          option.textContent = unitSet.name || 'Unbenannt'
          option.style.cssText = `
            padding: 8px 12px;
            cursor: ${isReadOnly ? 'not-allowed' : 'pointer'};
            transition: background-color 0.3s;
          `
          if (!isReadOnly) {
            option.onmouseenter = () => {
              option.style.backgroundColor = '#eee'
            }
            option.onmouseleave = () => {
              option.style.backgroundColor = 'transparent'
            }
            option.onclick = (e) => {
              e.stopPropagation()
              bumpUnitSetPrefillEpoch()
              selectedUnitSetId = unitSet.id
              selectSelectionItem.textContent = unitSet.name || 'Unbenannt'
              selectSelectionItem.style.color = '#000'
              dropdown.classList.add('ant-select-dropdown-hidden')
              void applyUnitSetSelection(unitSet.id)
            }
          }
          dropdownInner.appendChild(option)
        })
      }

      dropdownHolder.appendChild(dropdownInner)
      dropdownContent.appendChild(dropdownHolder)
      dropdown.appendChild(dropdownContent)
      dropdownWrapper.appendChild(dropdown)
      selectWrapper.appendChild(dropdownWrapper)
      selectContainer.appendChild(selectWrapper)

      // Handle click to show/hide dropdown (only if not disabled)
      if (!isReadOnly) {
        selectWrapper.onclick = (e) => {
          e.stopPropagation()
          const isHidden = dropdown.classList.contains('ant-select-dropdown-hidden')
          // Hide all other dropdowns
          document.querySelectorAll('.impowerx-select-dropdown').forEach(d => {
            d.classList.add('ant-select-dropdown-hidden')
          })
          if (isHidden) {
            dropdown.classList.remove('ant-select-dropdown-hidden')
          } else {
            dropdown.classList.add('ant-select-dropdown-hidden')
          }
        }
      }

      // Hide dropdown when clicking outside
      const handleClickOutside = (e) => {
        if (!selectContainer.contains(e.target)) {
          dropdown.classList.add('ant-select-dropdown-hidden')
        }
      }
      document.addEventListener('click', handleClickOutside)

      // Final check before appending
      if (targetElement.querySelector('.weg-unit-sets-select') || document.querySelector('.weg-unit-sets-select')) {
        isInjecting = false
        return true
      }

      targetElement.appendChild(selectContainer)

      const refreshSelectionItemColor = () => {
        selectSelectionItem.style.color = selectWrapper.classList.contains('ant-select-disabled')
          ? '#757575'
          : '#000'
      }

      const prefillUnitSetFromDistribution = async () => {
        const maxAttempts = 20
        const delayMs = 400
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
          let epoch = unitSetPrefillEpoch
          const token = JSON.parse(localStorage.getItem('auth'))?.token
          if (!token) {
            await new Promise((r) => setTimeout(r, delayMs))
            if (unitSetPrefillEpoch !== epoch) return
            continue
          }
          epoch = unitSetPrefillEpoch
          const accountCode = resolveDistributionAccountCode()
          if (!accountCode) {
            await new Promise((r) => setTimeout(r, delayMs))
            if (unitSetPrefillEpoch !== epoch) return
            continue
          }
          try {
            epoch = unitSetPrefillEpoch
            let distribution = await fetchDistributionAccount({
              token,
              propertyId,
              year: resolveDistributionEconomicYear(economicYear),
              accountCode,
            })
            if (unitSetPrefillEpoch !== epoch) return
            let match = findMatchingUnitSetSelection(unitSets, distribution)
            const needsTableForIds = unitSets.some((us) =>
              (us.units || []).some((u) => u.id == null && u.unitNrSharingDeclaration != null)
            )
            if (!match && needsTableForIds) {
              epoch = unitSetPrefillEpoch
              await new Promise((r) => setTimeout(r, 1200))
              if (unitSetPrefillEpoch !== epoch) return
              epoch = unitSetPrefillEpoch
              distribution = await fetchDistributionAccount({
                token,
                propertyId,
                year: resolveDistributionEconomicYear(economicYear),
                accountCode,
              })
              if (unitSetPrefillEpoch !== epoch) return
              match = findMatchingUnitSetSelection(unitSets, distribution)
            }
            const epochBeforeApply = unitSetPrefillEpoch
            if (unitSetPrefillEpoch !== epochBeforeApply) return
            if (match) {
              selectedUnitSetId = match.id
              selectSelectionItem.textContent = match.label
            } else {
              selectedUnitSetId = null
              selectSelectionItem.textContent = 'Einheitenset auswählen...'
            }
            refreshSelectionItemColor()
            return
          } catch {
            epoch = unitSetPrefillEpoch
            await new Promise((r) => setTimeout(r, delayMs))
            if (unitSetPrefillEpoch !== epoch) return
          }
        }
      }
      void prefillUnitSetFromDistribution()

      /** Wirtschaftsjahr in header can change without route rematch; re-prefill dropdown from API. */
      let lastYearSeenForUnitSetPrefill = undefined
      let yearChangeReprefillTimer = null
      const scheduleUnitSetPrefillOnYearChange = () => {
        clearTimeout(yearChangeReprefillTimer)
        yearChangeReprefillTimer = setTimeout(() => {
          const yStr = String(
            parseYearFromDistributionHeader() || resolveDistributionEconomicYear(economicYear) || '',
          )
          if (!yStr) return
          if (lastYearSeenForUnitSetPrefill === undefined) {
            lastYearSeenForUnitSetPrefill = yStr
            return
          }
          if (lastYearSeenForUnitSetPrefill === yStr) return
          lastYearSeenForUnitSetPrefill = yStr
          bumpUnitSetPrefillEpoch()
          selectedUnitSetId = null
          selectSelectionItem.textContent = 'Einheitenset auswählen...'
          refreshSelectionItemColor()
          void prefillUnitSetFromDistribution()
        }, 280)
      }
      const yearWatchHeader = document.querySelector('.DistributionKeyDetailsHeader')
      if (yearWatchHeader) {
        const yearHeaderObserver = new MutationObserver(() => scheduleUnitSetPrefillOnYearChange())
        yearHeaderObserver.observe(yearWatchHeader, {
          subtree: true,
          childList: true,
          characterData: true,
        })
      }

      // Function to reset unit set selection when checkboxes are manually changed
      const resetUnitSetSelection = () => {
        if (selectedUnitSetId !== null) {
          selectedUnitSetId = null
          selectSelectionItem.textContent = 'Einheitenset auswählen...'
          selectSelectionItem.style.color = '#757575'
        }
      }

      // Function to update disabled state
      const updateDisabledState = (readOnly) => {
        if (readOnly === isReadOnly) {
          return // No change needed
        }
        isReadOnly = readOnly
        
        if (readOnly) {
          selectWrapper.classList.add('ant-select-disabled')
          selectSelector.style.backgroundColor = '#eee'
          selectSelector.style.border = '.2rem solid transparent'
          selectSelector.style.cursor = 'not-allowed'
          refreshSelectionItemColor()
          selectWrapper.onclick = null
          dropdownInner.querySelectorAll('.ant-select-item-option').forEach(opt => {
            opt.style.cursor = 'not-allowed'
            opt.onclick = null
            opt.onmouseenter = null
            opt.onmouseleave = null
          })
        } else {
          selectWrapper.classList.remove('ant-select-disabled')
          selectSelector.style.backgroundColor = '#fff'
          selectSelector.style.border = '.2rem solid #eee'
          selectSelector.style.cursor = 'pointer'
          selectSelectionItem.style.color = '#000'
          selectWrapper.onclick = (e) => {
            e.stopPropagation()
            const isHidden = dropdown.classList.contains('ant-select-dropdown-hidden')
            document.querySelectorAll('.impowerx-select-dropdown').forEach(d => {
              d.classList.add('ant-select-dropdown-hidden')
            })
            if (isHidden) {
              dropdown.classList.remove('ant-select-dropdown-hidden')
            } else {
              dropdown.classList.add('ant-select-dropdown-hidden')
            }
          }
          dropdownInner.querySelectorAll('.ant-select-item-option').forEach(opt => {
            opt.style.cursor = 'pointer'
            const unitSetId = opt.dataset.value
            
            if (unitSetId === 'all') {
              // Handle "Alle Einheiten" option
              opt.onmouseenter = () => {
                opt.style.backgroundColor = '#eee'
              }
              opt.onmouseleave = () => {
                opt.style.backgroundColor = 'transparent'
              }
              opt.onclick = (e) => {
                e.stopPropagation()
                bumpUnitSetPrefillEpoch()
                selectedUnitSetId = 'all'
                selectSelectionItem.textContent = 'Alle Einheiten'
                selectSelectionItem.style.color = '#000'
                dropdown.classList.add('ant-select-dropdown-hidden')
                void applyUnitSetSelection('all')
              }
            } else {
              // Handle unit set options
              const unitSet = unitSets.find(us => us.id.toString() === unitSetId)
              if (unitSet) {
                opt.onmouseenter = () => {
                  opt.style.backgroundColor = '#eee'
                }
                opt.onmouseleave = () => {
                  opt.style.backgroundColor = 'transparent'
                }
                opt.onclick = (e) => {
                  e.stopPropagation()
                  bumpUnitSetPrefillEpoch()
                  selectedUnitSetId = unitSet.id
                  selectSelectionItem.textContent = unitSet.name || 'Unbenannt'
                  selectSelectionItem.style.color = '#000'
                  dropdown.classList.add('ant-select-dropdown-hidden')
                  void applyUnitSetSelection(unitSet.id)
                }
              }
            }
          })
        }
      }

      // Stay in sync with the host form: same heuristic as before — if any other Ant select is
      // `.ant-select-disabled`, the page is read-only (Bearbeiten not active). Observe DOM so we
      // do not depend on button labels/classes (Speichern/Bearbeiten are both primary in some builds).
      const syncUnitSetDropdownToFormReadOnly = () => {
        const scope = getDistributionKeyDetailsActionScope()
        if (!scope) {
          updateDisabledState(true)
          return
        }
        const otherDisabledSelects = Array.from(scope.querySelectorAll('.ant-select.ant-select-disabled')).filter(
          (select) => !select.closest('.weg-unit-sets-select')
        )
        updateDisabledState(otherDisabledSelects.length > 0)
      }

      const formReadOnlyObserver = new MutationObserver(() => {
        syncUnitSetDropdownToFormReadOnly()
      })
      const actionScope = getDistributionKeyDetailsActionScope()
      if (actionScope) {
        formReadOnlyObserver.observe(actionScope, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['class', 'disabled'],
        })
      }

      // Watch for manual checkbox changes to update unit set selection
      const handleCheckboxChange = (e) => {
        // Only process if not programmatically updating and checkbox is in the distribution key table
        if (isUpdatingCheckboxes) {
          return
        }
        
        const checkbox = e.target.closest('.ant-checkbox')
        if (!checkbox) {
          return
        }
        
        const distributionKeyDetails = document.querySelector('#distributionKeyDetails')
        if (!distributionKeyDetails || !distributionKeyDetails.contains(checkbox)) {
          return
        }
        
        // Debounce the update to avoid multiple calls
        clearTimeout(handleCheckboxChange.timeoutId)
        handleCheckboxChange.timeoutId = setTimeout(() => {
          resetUnitSetSelection()
        }, 100)
      }
      document.addEventListener('click', handleCheckboxChange)

      syncUnitSetDropdownToFormReadOnly()

      isInjecting = false
      return true
    } catch (error) {
      console.error('Error injecting unit-sets select:', error)
      isInjecting = false
      return false
    }
  }

  // Wait for the target element to be present
  let attempts = 0
  const maxAttempts = 60 // 30 seconds max (60 * 500ms)
  let observer = null
  
  const waitForElement = setInterval(async () => {
    attempts++
    const injected = await injectUnitSetsSelect()
    if (injected) {
      clearInterval(waitForElement)
      if (observer) {
        observer.disconnect()
      }
    }
    if (attempts >= maxAttempts) {
      clearInterval(waitForElement)
      if (observer) {
        observer.disconnect()
      }
    }
  }, 500)

  // Also observe for when the element appears
  observer = new MutationObserver(async () => {
    // Check if already injected before trying again
    if (!document.querySelector('.weg-unit-sets-select')) {
      const injected = await injectUnitSetsSelect()
      if (injected && observer) {
        observer.disconnect()
      }
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

